export default require('../otherChains/blast').default.rpcUrls.default.http[0]